import store from "../store/store";
import {useEffect, useState} from "react";
import Shop from "../shop";

function useShopGroup() {
  const [state, setState] = useState(store.getState());

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setState(store.getState());
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return [state.group, Shop];
}

export default useShopGroup;
